module.exports = __webpack_public_path__ + "img/boat.6970115e.svg";